import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// import Vuetify from 'vuetify/lib' // a-la-carte (treeshaking)

// own translation files
import vde from 'vuetify/es5/locale/de'
import ven from 'vuetify/es5/locale/en'
import ide from '../i18n/de'
import ien from '../i18n/en'
import gfde from '../plugins/vue-gridform/i18n/de'
import gfen from '../plugins/vue-gridform/i18n/en'
const de = {...vde, ...ide, ...gfde}
const en = {...ven, ...ien, ...gfen}
const lang = 'de'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            dark: {
                primary: '#ff3c00',
                secondary: '#1c3257',
                accent: '#0a000a',
                error: '#d91111',
                warning: '#F5BC00',
                info: '#42A4F5',
                success: '#49BA4E'
            },
            light: {
                primary: '#1c3257',
                secondary: '#ffffff',
                accent: '#ff3c00',
                error: '#d91111',
                warning: '#F5BC00',
                info: '#42A4F5',
                success: '#49BA4E'
            }
        }
    },
    icons: {
        iconfont: 'mdi' // default - only for display purposes
    },
    lang: {
        locales: {de, en},
        current: lang
    }
})
